import React from 'react';
import { Navbar, Container } from 'react-bootstrap';


const Header = () => {
    return (
        <Navbar bg="light" variant="light" expand="lg" className="py-0 mb-3" style={{ borderBottom: '1px solid #e0e0e0' }}>
            <Container fluid className="px-3">
                <Navbar.Brand href="#home" className="p-0" aria-label="Clean ERP">
                    <img
                        src="/clean-erp-logo.png"
                        alt="Clean ERP"
                        style={{ height: 50, display: 'block' }}
                        className="d-inline-block"
                    />
                </Navbar.Brand>
            </Container>
        </Navbar>
    );
};

export default Header;
